import cjson from 'compressed-json';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, Subject } from 'rxjs';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { CallStage } from 'src/app/enums/CallStage';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import * as _ from 'underscore';
import { JdDataService } from 'src/app/jd-data.service';
import { Location } from '@angular/common';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';

@Component({
    selector: 'app-report-titles',
    templateUrl: './report-titles.component.html',
    styleUrls: ['./report-titles.component.scss'],
    standalone: false
})
export class ReportTitlesComponent implements OnInit {
  talentfilterdata: any = {};
  aggregatescount: number = 50;
  totalCount: number = 0;
  @ViewChild('titlesort') titlesort: MatSort;
  displayedColumns: string[] = ['key', 'doc_count', 'totalTenure', 'job_doc_count', 'median_salary', 'topemployers',];

  currentPage: number = 1;
  pageSize: number = 10;
  totalResultCount: any
  currentjobtitledata: any[] = []
  currentjobtitles: any
  start: number = 0;
  end: number = 10;
  titlesarray: any[] = [];
  isApiCalled: boolean = false;
  subscriptions: Array<Subscription> = [];
  /**Sorted data of visible pages */
  titlesSortData: any;
  /**top employers data loaded */
  hasTopEmployer: boolean = false;

  insightsExportSubscription: Subscription = null;

  @ViewChild('functionsort') functionsort = new MatSort();
  /**Columns to be displayed for function data */
  displayedfunctionsColumns: string[] = ['key', 'doc_count', '%total', 'median_tenure', 'job_doc_count', 'median_salary'];
  /**Used to store function aggregates count */
  functionAggregatesCount: number = 50;

  functionsortdata: any[] = [];
  /**Total count of function data in Response */
  totalCountFunction: number = 0;
  /**Total data present in elasticsearch */
  totalResultCountFunction: number = 0;
  /**Used to show/hide loader for function aggregates api */
  isFunctionPending: boolean = false;
  functionsdata: any;
  functions: any[] = [];
  /**Start index for function data */
  startFunction: number = 0;
  /**End index for function data */
  endFunction: number = 5;
  /**Current page for function data */
  currentFunctionPage: number = 1;
  /**Page size for function data */
  pageSizeFunction: number = 5;

  functionTableHeaderObj = {
    "Function": "Functions",
    "TalentCount": "Talent Count",
    "PercentageOfTotal": "% of Total",
    "MedianTenure": "Median Tenure",
    "JobDemand": "Job Posts",
    "MedianSalary": "Salary Range"
  }
  /**Used to show/hide loader for function salary api */
  isFunctionSalaryPending: boolean = false;

  /**Used to store currency data for function median salary */
  functionCurrencyData: any = {
    "target_currency_rate": 1,
    "currency": null,
    "target_fav_icon": 'fa-dollar-sign',
    "currency_symbol": '$',
  }


 /**
 * Mapping of key and text value of headers
 * In case if have to add new key or modified existing one, also need to update `tableHeaderName` accordingly
 */
  tableHeaderObj = {
    "Titles": "Titles",
    "TalentCount": "Talent Count",
    "MedianOverallExp": "Median Overall Exp",
    "TopEmployers": "Top Employers",
    "JobDemand": "Job Posts",
    "MedianSalary": "Salary Range"
  }

  /**
   * Used to send as payload for export pdf.
   * Use key that need to be shown in pdf.
   * Must follow correct order as used in HTML file
   */
  tableHeaderName: string[] = [];

  senioritytableHeaderObj = {
    "Title": "Title Levels",
    "TalentCount": "Talent Count",
    "JobDemand": "Job Posts",
    "MedianSalary": "Salary Range"
  }
  displayedSeniorityColumns: string[] = ['key', 'doc_count', 'job_doc_count', 'median_salary'];


  get isLocationEurope() {
    const hasEUTIAccess = this.localstorageservice.getItem('hasEUTalentInsightsAccess');
    const hasEUPSAccess = this.localstorageservice.getItem('hasEUPersonSearchAccess')

    if (!hasEUPSAccess)
      return this.localstorageservice.getItem('talentRegion') == 'europe';
  }
  jobtitledataAI: any = {};
  combinedAggregates: any;
  combinedIndustry: any[] = [];
  combinedSkills: any[] = [];
  combinedJobtitle: any[] = [];
  combinedLocation: any[] = [];
  hasJobDemand: boolean = false;
  senioritySortData: any= [];
  totalCountSeniority: number = 0;
  currentsenioritydata: any[] = []
  currentseniority: any
  @ViewChild('senioritySort') senioritySort: MatSort;
  isSeniorityApiCalled: boolean = false;
  currencyData: any[] = [];
  filteredCurrencies: any[] = [];
  selectedCurrency: any = null;
  target_currency_rate: number = 1
  target_fav_icon: string = 'fa-dollar-sign';
  currency_symbol: string = '$';
  hasMedianSalary: boolean = false;
  seniorityCurrency: any;
  currency: any;
  target_currency_rate_seniority: number = 1
  target_fav_icon_seniority: string = 'fa-dollar-sign';
  hasMedianSalarySeniority: boolean = false;
  filterData: any;
  aiSuggestions: any = {};
  titlesJobAggregates: any;
  seniorityJobsAggregates: any;
  filterType: string[] = [];
isComingFromJD: boolean = false;
isComingFromNLSearch: boolean = false;
functionsAggregates: any;

   sendDataToSliderSubject: Subject<any> = new Subject();
  toOpenSliderFromTabSubject: Subject<any> = new Subject();
  titlesTabPayload:any
  titlesTabFunctionsPayload:any
  titlesTabSeniorityPayload:any
  hasJobListingAccess:any
  filters: any;

  constructor(
    private personsearchservice: PersonSearchService, private localstorageservice: LocalStorageService, private router: Router,
    private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private aggService: AggregationService,
    private filterDataHandlerService: FilterDataHandlerService,
    private hashService: HashService
    , private talentInsightsService: TalentInsightsService, private jdService: JdDataService, private location: Location,
  private route: ActivatedRoute) {

    const statemanagementSub = this.location.subscribe((p) => {
      const urlParams = new URLSearchParams(p.url.split('?')[1]);
      const filterKey = urlParams.get('filter');
      if (filterKey) {
        const cacheRequest = localStorage.getItem(filterKey);
        if (cacheRequest) {
          const filterData = cjson.decompress(JSON.parse(cacheRequest));
          this.filterDataHandlerService.setFilterData(filterData);
        }
      }
      this.setUpdatedData(null);
    });
  }

  ngOnInit(): void {
    if (this.jdService.isComingFromJobDescription) this.isComingFromJD = true;
    if (this.jdService.isComingFromNLSearch) this.isComingFromNLSearch = true;
    this.getCurrencyData();
    const filterMethodEvent = this.filterDataHandlerService.filterMethodEvent.subscribe(_methodDetails => {
      this.filterData = _methodDetails;
      this.getCurrencyData('filterChange');
    });
    this.subscriptions.push(filterMethodEvent);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.talentInsightsService.insightsExportRequestEvent.subscribe((requestData: { type?: string, action?: string, data?: { currentTab?: string } }) => {
      if (requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subscriptions.push(this.insightsExportSubscription);
    const jdUpdateEvent = this.jdService.getInsightsEvent().subscribe((res: any) => {
      if (res.action == 'refresh' && res.tab == this.talentInsightsService.INSIGHTS_TABS.TITLES) {
        this.filterType = res.filterType;
        this.getCurrencyData('jdUpdate');
      }
    });
    this.subscriptions.push(jdUpdateEvent);
    const aiSuggestionSub = this.talentInsightsService.aiSuggesionData.subscribe(data => {
      this.aiSuggestions = data;
      if (!this.aiSuggestions) {
        this.aiSuggestions = this.talentInsightsService.getAISuggestionData();
      }
      this.setUpdatedData();
    });
    this.subscriptions.push(aiSuggestionSub);
    this.hasJobListingAccess = this.localstorageservice.getItem('hasjoblistingaccess')
  }
  fetchInsightsTabData() {
    // const titlessubscription = this.personsearchservice.gettalentinsights.subscribe((response) => this.setUpdatedData(response));
    // this.subscriptions.push(titlessubscription);


  }

  private setUpdatedData(talentFilterData?: any) {
    if (talentFilterData) {
      this.talentfilterdata = talentFilterData
    }
    this.start = 0;
    this.end = 10;
    this.currentPage = 1;
    this.hasTopEmployer = false;
    this.setPageFunction(1);
    this.getcurrentjobtitles();
    this.getFunction();
    this.personsearchservice.setTalentinsightsFilterAI(this.filterDataHandlerService.fetchFilterData)
  }


  getcurrentjobtitles() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = 'current_jobtitle-total_tenure_median';
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personsearchservice.getTotalAggs(aggReq, true).subscribe((response) => {
      this.isApiCalled = true;
      this.totalResultCount = response.data.totalresultscount;

      const tempData = response.data.aggregations['current_jobtitle-total_tenure_median'];
      this.titlesarray = _.pluck(tempData, 'key')
      tempData.map(res => {
        res.total_tenure = res.total_tenure_median.value != null ? res.total_tenure_median.value : 0;
        return res;
      });
      this.titlesSortData = tempData;
      this.totalCount = tempData.length;
      this.currentjobtitledata = tempData.slice(this.start, this.end);

      this.currentjobtitles = new MatTableDataSource(this.currentjobtitledata);
      this.currentjobtitles.sort = this.titlesort;
      this.gettopemployers();
      this.manualSort();
      this.getSeniority();

      this.getindustriesdataai(this.titlesSortData)
    });
  }

  getjobtitlepercentage(value) {
    return ((value / this.totalResultCount) * 100).toFixed(2);
  }

  manualSort() {
    this.reSortArr(this.titlesort)
  }
  reSortArr(sort) {
    const tempData = this.titlesSortData;

    if (!sort || !sort.active || sort.direction === '') {
      this.currentjobtitledata = tempData.slice(this.start, this.end);
      this.currentjobtitles = new MatTableDataSource(this.currentjobtitledata);
      this.currentjobtitles.sort = this.titlesort;
      return;
    }

    this.titlesSortData = tempData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case '%total': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'totalTenure': return this.compare(a.total_tenure, b.total_tenure, isAsc);
        case 'job_doc_count': return this.compare(a.job_doc_count, b.job_doc_count, isAsc);
        default: return 0;
      }
    });

    this.currentjobtitledata = this.titlesSortData.slice(this.start, this.end);
    this.currentjobtitles = new MatTableDataSource(this.currentjobtitledata);
    this.currentjobtitles.sort = this.titlesort;
  }

  compare(a: number, b: number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  setPage(index: number) {
    this.start = (index - 1) * this.pageSize;
    this.end = this.start + this.pageSize;
    this.currentPage = index;

    this.manualSort();


  }

  gettopemployers() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_jobtitle-current_company";
    aggReq.aggregatescount = this.aggregatescount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);

    this.personsearchservice.getTotalAggs(aggReq, true).subscribe((response) => {
      this.hasTopEmployer = true;
      const tempData = response.data.aggregations['current_jobtitle-current_company'];
      this.titlesSortData.map(res => {
        const companies = tempData.filter(x => x.key.toLowerCase().trim() == res.key.toLowerCase().trim());
        if (companies.length > 0) {
          res.companynames = _.pluck(companies[0].job_company_name.buckets, 'key').join(', ');
          return res;
        }
      })
      this.getindustriesdataai(this.titlesSortData)
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param key
   */
  handelRedirection(type: string, key: string) {
    if (this.isLocationEurope) return;
    this.filters = this.filterDataHandlerService.fetchFilterData;

    const redirectFilters: Partial<FilterParams> = {
      insightsFilterData: this.filters,
    };


    switch (type) {
      case 'jobtitle': redirectFilters['mandatoryjobtitles'] = [key]; break;
      case 'functions': redirectFilters['mandatoryfunctions'] = [key]; break;
    }

     const aggReq = this.aggService.getRequestWithFilters();
        if (aggReq?.continentstobeincluded) {
          redirectFilters['continentstobeincluded'] = aggReq.continentstobeincluded;
        }
        if (aggReq?.nlsearchquery) {
          redirectFilters['nlsearchquery'] = aggReq.nlsearchquery;
        }

        const uniqueKey = this.hashService.generateUniqueHash();
        localStorage.setItem(uniqueKey, JSON.stringify(cjson.compress(redirectFilters)));

        // Forward the SAME UNIQUE_HASH this page was loaded with, so the listing page's
        // jdDataFromSession getter finds job_description-${jdUniqueHash} in the sessionStorage
        // that window.open() clones into the new tab.
        const jdUniqueHash = this.route.snapshot.queryParamMap.get(GeneralConstants.LS_KEYS.UNIQUE_HASH);

        let url = `/candidate-list?type=search&redirectSource=talent-insights&key=${uniqueKey}`;

        if ((this.isComingFromJD || this.isComingFromNLSearch) && jdUniqueHash) {
          url += `&${GeneralConstants.LS_KEYS.UNIQUE_HASH}=${jdUniqueHash}`;
        }

        window.open(url, '_blank');
  }

  private getFormattedTenure(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if (totalYears > 0 && totalMonths > 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'} ${totalMonths} Mths`;
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? 'Yr' : 'Yrs'}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      return `${totalMonths} Mths`;
    } else {
      return '';
    }
  }

  getindustriesdataai(data, type = 'titles') {
    let titlesdata: any;
    if (type == 'titles') {
      titlesdata = data.map(x => {
        let res: any = {};
        res['Titles'] = x.key;
        res['Talent Count'] = x.doc_count;
        res['% of Total'] = this.getjobtitlepercentage(x.doc_count) + '%';
        res['Top Employers'] = x.companynames;
        res['Median Overall Exp'] = Math.round(x.total_tenure * 100) / 100 + 'yrs';
        res['Job Posts'] = x.job_doc_count || 0;
        if (x.median_salary_min) {
          res['median salary offered min'] = x.median_salary_min;
        }
        if (x.median_salary_max) {
          res['median salary offered max'] = x.median_salary_max ?? null;
        }
        res['Salary currency'] = this.selectedCurrency?.target_currency;
        return res;
      })
      this.modifyCurrencyDataForAi(titlesdata);
      this.jobtitledataAI['jobtitles'] = titlesdata;

    }
    if(type == 'seniority') {
      let skillsdata: any = [];
      skillsdata = data.map(x => {
        let res: any = {};
        res['Title'] = x.key;
        res['Talent Count'] = x.doc_count;
        res['Job Demand'] = x.job_doc_count || 0;
        if (x.median_salary_min) {
          res['median salary offered min'] = x.median_salary_min;
        }
        if (x.median_salary_max) {
          res['median salary offered max'] = x.median_salary_max ?? null;
        }
        res['Salary currency'] = this.seniorityCurrency;
        return res;
      });
      this.modifyCurrencyDataForAi(skillsdata);
      this.jobtitledataAI['seniority'] = skillsdata

    }
    if(type == 'functions') {
      let functionsdata: any = [];
      functionsdata = data.map(x => {
        let res: any = {};
        res['Titles'] = x.key;
        res['Talent Count'] = x.doc_count;
        res['Percentage of Total'] = this.getjobtitlepercentage(x.doc_count) + '%';
        res['Median Tenure'] = Math.round(x.median_tenure * 100) / 100 + 'yrs';
        res['Job Demand'] = x.job_doc_count || 0;
        if(x.median_salary_min){
          res['median salary offered min'] = x.median_salary_min;
        }
        if(x.median_salary_max){
          res['median salary offered max'] = x.median_salary_max ?? null;
        }
        res['Salary currency'] = this.functionCurrencyData.currency;
        return res;
      });
      this.modifyCurrencyDataForAi(functionsdata);
      this.jobtitledataAI['functions'] = functionsdata;
    }

    if (this.jobtitledataAI?.jobtitles?.length == 0 && this.jobtitledataAI?.seniority?.length == 0 && this.jobtitledataAI?.functions?.length == 0) {
      this.jobtitledataAI = null;
    }
  }

  /**
   * Format currency data
   * @param aiData Already formatted ai data
   * @returns
   */
  modifyCurrencyDataForAi(aiData) {
    if (!aiData || !Array.isArray(aiData)) {
      return;
    }
    aiData.forEach(item => {
      if (item['median salary offered max']) {
        item['median salary offered max'] = item['median salary offered max'] * this.target_currency_rate;
      }
      if (item['median salary offered min']) {
        item['median salary offered min'] = item['median salary offered min'] * this.target_currency_rate;
      }
      if (this.selectedCurrency?.target_currency) {
        item['Salary currency'] = this.selectedCurrency?.target_currency
      }
    });
  }


  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: { type?: string, action?: string, data?: { currentTab?: string } }) {
    if (requestData?.data?.currentTab !== this.talentInsightsService.INSIGHTS_TABS.TITLES) return;
    this.tableHeaderName = [this.tableHeaderObj["Titles"], this.tableHeaderObj["TalentCount"], this.tableHeaderObj["MedianOverallExp"], this.tableHeaderObj["JobDemand"], this.tableHeaderObj["MedianSalary"], this.tableHeaderObj["TopEmployers"]];
    const senioritytableHeaderObj = [this.senioritytableHeaderObj["Title"], this.senioritytableHeaderObj["TalentCount"], this.senioritytableHeaderObj["JobDemand"], this.senioritytableHeaderObj["MedianSalary"]];
    const functionTableHeaderWithOrder = [this.functionTableHeaderObj["Function"], this.functionTableHeaderObj["TalentCount"], this.functionTableHeaderObj["PercentageOfTotal"], this.functionTableHeaderObj["MedianTenure"], this.functionTableHeaderObj["JobDemand"], this.functionTableHeaderObj["MedianSalary"]];
      const functionsDataForExport = this.functionsortdata.map(fun => {
      return {
        ...fun,
        job_doc_count: fun.job_doc_count || '—',
        median_salary: fun.median_salary != 'N/A' ? fun.median_salary : '—',
      }
    });

    const seniorityDataForExport = this.senioritySortData.map(sen => {
      return {
        ...sen,
        job_doc_count: sen.job_doc_count || '—',
        median_salary: sen.median_salary != 'N/A' ? sen.median_salary : '—',
      }
    });

    const titlesDataForExport = this.titlesSortData.map(title => {
      return {
        ...title,
        job_doc_count: title.job_doc_count || '—',
        median_salary: title.median_salary != 'N/A' ? title.median_salary : '—',
      }
    });
    const payloadForInsightsExport = {
      tab: 'titles',
      totalresultcount: this.totalResultCount,
      titles: titlesDataForExport,
      tableHeader: this.tableHeaderName,
      seniority: {tableHeader: senioritytableHeaderObj, data: seniorityDataForExport},
      functions: {tableHeader: functionTableHeaderWithOrder, data: functionsDataForExport, totalresultcountfunction: this.totalResultCountFunction},
      currencySymbol: this.currency_symbol
    }
    this.talentInsightsService.sendInsightsExportData(payloadForInsightsExport);
  }

  getJobsAggregates() {
    this.hasMedianSalary = true;
    this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions');
    const aggReq = this.aggService.getRequestWithFilters();
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      aggregatetype: 'jobtitle-median_salary',
      startindex: 0,
      resultsize: 50,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations || [],
      industries: aggReq?.industries || [],
      companies: aggReq?.companies || [],
      functions: aggReq?.functions || [],
      seniority: aggReq?.seniority || [],
      excluded_jobtitles: aggReq?.exclude_jobtitles || [],
      excluded_locations: aggReq?.exclude_locations || [],
      excluded_companies: aggReq?.exclude_companies || [],
      excluded_industries: aggReq?.exclude_industries || [],
      distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
      distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
       aggregatescount: 50,
           excluded_functions: aggReq?.exclude_functions || [],
excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],
   }
      if (this.isComingFromJD || this.isComingFromNLSearch) {
             payload['jobDescriptionKeys'] = {
               jobtitles: jobtitles,
               mandatory_jobtitles: aggReq?.job_description_keys?.mandatory_job_titles || [],
               skills: skills,
               mandatory_skills: aggReq?.job_description_keys?.mandatory_skills || [],
               locations: aggReq?.job_description_keys?.locations || [],
               mandatory_locations: aggReq?.job_description_keys?.mandatory_locations || [],
               mandatory_company_sizes: aggReq?.job_description_keys?.mandatory_company_sizes || [],
               companies: aggReq?.job_description_keys?.companies || [],
               mandatory_companies: aggReq?.job_description_keys?.mandatory_companies || [],
               industries: aggReq?.job_description_keys?.industries || [],
               mandatory_industries: aggReq?.job_description_keys?.mandatory_industries || []
             }
             payload.jobtitles = _.uniq(aggReq?.jobtitles.concat(aggReq?.pastjobtitles)) || [];
             payload.skills = _.uniq(aggReq?.preferredskills?.concat(aggReq?.mandatoryskills)) || [];
           }
               this.titlesTabPayload = payload


    if (jobtitles?.length > 0 && skills?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
        this.hasJobDemand = false;
        this.hasMedianSalary = false;
        this.titlesJobAggregates = [];
        this.setTitlesJobAggregates();
      }else if(!this.isComingFromJD && !this.isComingFromNLSearch && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')){
   this.hasJobDemand = false;
        this.hasMedianSalary = false;
        this.titlesJobAggregates = [];
        this.setTitlesJobAggregates();
      }

      else {
        this.talentInsightsService.getJobsAggregates(payload).subscribe((response: any) => {
          const tempData = response?.data?.aggregations['jobtitle-median_salary'];
          this.hasJobDemand = false;
          this.hasMedianSalary = false;
          this.titlesJobAggregates = tempData;
          this.setTitlesJobAggregates();

        })
      }

    } else {
      this.hasJobDemand = false;
      this.hasMedianSalary = false;
      this.titlesJobAggregates = [];
      this.setTitlesJobAggregates();
    }
  }

formatNumber(value: number): string| number {
  if (value === null || value === undefined || isNaN(value)) return '0';

  const country = this.localstorageservice.getItem('currencyCountry');
  const absNum = Math.abs(value);

  // Optional: you can fetch dynamically if you store currency symbol
  const currencySymbol = country?.toLowerCase() === 'india' ? '₹' : '$';

  const format = (num: number) => {
    return num % 1 === 0 ? num.toString() : num.toFixed(1);
  };

  if (country?.toLowerCase() === 'india') {

    if (absNum >= 1e7) { // 1,00,00,000
      return format(value / 1e7) + 'Cr';
    }

    if (absNum >= 1e5) { // 1,00,000
      return format(value / 1e5) + 'L';
    }

    if (absNum >= 1e3) {
      return format(value / 1e3) + 'K';
    }

    return value;
  }

  else {

    if (absNum >= 1e9) {
      return format(value / 1e9) + 'B';
    }

    if (absNum >= 1e6) {
      return format(value / 1e6) + 'M';
    }

    if (absNum >= 1e3) {
      return format(value / 1e3) + 'K';
    }

    return value;
  }
}



  getSeniority() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "seniority";
    aggReq.aggregatescount = this.aggregatescount;

    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.isSeniorityApiCalled = true;
    this.personsearchservice.getTotalAggs(aggReq, true).subscribe((response) => {
      this.isSeniorityApiCalled = false;
      const tempData = response.data.aggregations['seniority'];
      this.senioritySortData = tempData;
      this.totalCountSeniority = tempData.length;

      this.currentseniority = new MatTableDataSource(this.senioritySortData);
      this.currentseniority.sort = this.senioritySort;
      this.manualSortSeniority();
      if(this.senioritySortData.length == 0){
          this.isSeniorityApiCalled = false;
          this.currentseniority = {};

      }
      if ((!this.filterData && this.filterType.length == 0) || (this.filterData?.filterType == 'location' || this.filterData?.filterType == 'industry' || this.filterData?.filterType == 'company' || this.filterData?.filterType == 'seniority' || this.filterData?.filterType == 'functions' || this.filterData?.filterType == 'locationRange' || this.filterData?.filterType == 'skills' || this.filterData?.filterType == 'jobtitle' || this.filterData?.filterType == 'keyword' || this.filterData?.filterType == 'search' || this.filterData?.filterType == 'pastjobtitle') ||
        ((this.filterType?.length > 0 && (this.filterType?.includes('skills') || this.filterType?.includes('jobtitle') || this.filterType?.includes('industry') || this.filterType?.includes('company'))))) {

        this.getCurrency();
      }  else if(this.filterData?.filterType == 'allfilters' && !this.isComingFromJD && !this.isComingFromNLSearch) {
          this.functionsortdata = this.functionsortdata.map(title => {
        title.median_salary = "N/A";
        title.confidence_score = "N/A";
        title.job_doc_count = 0;
        return title;
      })
            this.senioritySortData = this.senioritySortData.map(title => {
        title.median_salary = "N/A";
        title.confidence_score = "N/A";
        title.job_doc_count = 0;
        return title;
      });
        this.titlesSortData = this.titlesSortData.map(title => {
        title.median_salary = "N/A";
        title.confidence_score = "N/A";
        title.job_doc_count = 0;
        return title;
      })

      this.localstorageservice.setItem('jobCurrency', 'USD');
      this.localstorageservice.setItem('currencyCountry', null);
         this.talentInsightsService.getCountryCurrency().subscribe((response: any) => {
      this.currencyData = response?.data;
      this.filteredCurrencies = this.currencyData.slice(0, 5);
      const currency = this.localstorageservice.getItem('jobCurrency');

      if (currency) {
        const selectedCurrency = this.currencyData.find((x: any) => x.target_currency === currency);
        if (selectedCurrency) {
          this.selectedCurrency = selectedCurrency;
          this.target_currency_rate = selectedCurrency.rate;
          this.currency = selectedCurrency.target_currency;
          this.target_fav_icon = selectedCurrency.target_currency_fav_icon;
          this.seniorityCurrency = selectedCurrency.target_currency;
          this.target_currency_rate_seniority = selectedCurrency.rate;
          this.target_fav_icon_seniority = selectedCurrency.target_currency_fav_icon;
          this.currency_symbol = selectedCurrency.target_currency_symbol;
                this.functionCurrencyData.currency =  selectedCurrency.target_currency;
      this.functionCurrencyData.target_currency_rate = selectedCurrency.rate;
      this.functionCurrencyData.target_fav_icon =  selectedCurrency.target_currency_fav_icon;

        }
      }

    })

      }

      else {

        this.setSeniorityJobsAggregates();
        this.setTitlesJobAggregates();
        this.setFunctionJobsAggregates();
      }

    })
  }

  getSeniorityAggregates() {
    this.hasMedianSalarySeniority = true;
    this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions');
    const aggReq = this.aggService.getRequestWithFilters();
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      aggregatetype: 'seniority-median_salary',
      startindex: 0,
      resultsize: 50,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations || [],
      industries: aggReq?.industries || [],
      companies: aggReq?.companies || [],
      functions: aggReq?.functions || [],
      seniority: aggReq?.seniority || [],
      excluded_jobtitles: aggReq?.exclude_jobtitles || [],
      excluded_locations: aggReq?.exclude_locations || [],
      excluded_companies: aggReq?.exclude_companies || [],
      excluded_industries: aggReq?.exclude_industries || [],
      distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
      distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
      aggregatescount: 50,
           excluded_functions: aggReq?.exclude_functions || [],
excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],
    }
       if (this.isComingFromJD || this.isComingFromNLSearch) {
              payload['jobDescriptionKeys'] = {
                jobtitles: jobtitles,
                mandatory_jobtitles: aggReq?.job_description_keys?.mandatory_job_titles || [],
                skills: skills,
                mandatory_skills: aggReq?.job_description_keys?.mandatory_skills || [],
                locations: aggReq?.job_description_keys?.locations || [],
                mandatory_locations: aggReq?.job_description_keys?.mandatory_locations || [],
                mandatory_company_sizes: aggReq?.job_description_keys?.mandatory_company_sizes || [],
                companies: aggReq?.job_description_keys?.companies || [],
                mandatory_companies: aggReq?.job_description_keys?.mandatory_companies || [],
                industries: aggReq?.job_description_keys?.industries || [],
                mandatory_industries: aggReq?.job_description_keys?.mandatory_industries || []
              }
              payload.jobtitles = _.uniq(aggReq?.jobtitles.concat(aggReq?.pastjobtitles)) || [];
              payload.skills = _.uniq(aggReq?.preferredskills?.concat(aggReq?.mandatoryskills)) || [];
            }

                this.titlesTabSeniorityPayload = payload

    if (jobtitles?.length > 0 && skills?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
        this.hasJobDemand = false;
        this.isSeniorityApiCalled = false;
        this.hasMedianSalarySeniority = false;
        this.seniorityJobsAggregates = [];
        this.setSeniorityJobsAggregates();
      }  else if(!this.isComingFromJD && !this.isComingFromNLSearch && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')){
     this.hasJobDemand = false;
        this.isSeniorityApiCalled = false;
        this.hasMedianSalarySeniority = false;
        this.seniorityJobsAggregates = [];
        this.setSeniorityJobsAggregates();
      }

      else {
        this.talentInsightsService.getJobsAggregates(payload).subscribe((response: any) => {
          const tempData = response?.data?.aggregations['seniority-median_salary'];
          this.hasJobDemand = false;
          this.isSeniorityApiCalled = false;
          this.hasMedianSalarySeniority = false;
          this.seniorityJobsAggregates = tempData;
          this.setSeniorityJobsAggregates();

        })
      }

    } else {
      this.hasJobDemand = false;
      this.hasMedianSalarySeniority = false;
      this.seniorityJobsAggregates = [];
      this.setSeniorityJobsAggregates();
    }
  }

  getFunction() {
    let aggReq = this.talentInsightsReqHandlerService.talentInsightRequest;
    aggReq.aggregatetype = "current_function-current_tenure_median";
    aggReq.aggregatescount = this.functionAggregatesCount;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.isFunctionPending = true;
    this.isFunctionSalaryPending = true
    this.personsearchservice.getTotalAggs(aggReq).subscribe((response) => {
      const tempData = response.data.aggregations['current_function-current_tenure_median'];
      this.totalResultCountFunction = response.data.totalresultscount;
      tempData.map(res => {
        res.median_tenure = res.current_tenure_median.value;
        return res;
      });
      this.functionsortdata = tempData;
      this.totalCountFunction = tempData.length;
      this.manualfunctionsort();
      this.isFunctionPending = false;
    });
  }

  manualfunctionsort() {
    this.reSortfunctionArray(this.functionsort);
  }

  reSortfunctionArray(sort) {
    const data = this.functionsortdata;
    if (!sort || !sort.active || sort.direction === '') {
      this.functions = data.slice(this.startFunction, this.endFunction);
      this.functionsdata = new MatTableDataSource(this.functions)
      return;
    }

    this.functionsortdata = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case '%total': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'median_tenure': return this.compare(a.median_tenure, b.median_tenure, isAsc);
        default: return 0;
      }
    });
    this.functions = this.functionsortdata.slice(this.startFunction, this.endFunction);
    this.functionsdata = new MatTableDataSource(this.functions)
  }

 getFunctionAggregate() {
    this.isFunctionSalaryPending = true;
     this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions');
    const aggReq = this.aggService.getRequestWithFilters();
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    const payload = {
      aggregatetype: 'function-median_salary',
      startindex: 0,
      resultsize: 50,
      skills: skills,
      jobtitles: jobtitles,
      locations: aggReq?.locations || [],
      industries: aggReq?.industries || [],
      companies: aggReq?.companies || [],
      functions: aggReq?.functions || [],
      seniority: aggReq?.seniority || [],
      excluded_jobtitles: aggReq?.exclude_jobtitles || [],
      excluded_locations: aggReq?.exclude_locations || [],
      excluded_companies: aggReq?.exclude_companies || [],
      excluded_industries: aggReq?.exclude_industries || [],
      distancefromselectedlocations: aggReq?.distancefromselectedlocations || 20,
      distancefromselectedlocationsmeasurementunit: aggReq?.distancefromselectedlocationsmeasurementunit || 'kilometers',
      aggregatescount: 50,
        excluded_functions: aggReq?.exclude_functions || [],
excluded_skills: aggReq?.exclude_mandatoryskills.concat(aggReq?.exclude_preferredskills || []) || [],
    }
       if (this.isComingFromJD || this.isComingFromNLSearch) {
              payload['jobDescriptionKeys'] = {
                jobtitles: jobtitles,
                mandatory_jobtitles: aggReq?.job_description_keys?.mandatory_job_titles || [],
                skills: skills,
                mandatory_skills: aggReq?.job_description_keys?.mandatory_skills || [],
                locations: aggReq?.job_description_keys?.locations || [],
                mandatory_locations: aggReq?.job_description_keys?.mandatory_locations || [],
                mandatory_company_sizes: aggReq?.job_description_keys?.mandatory_company_sizes || [],
                companies: aggReq?.job_description_keys?.companies || [],
                mandatory_companies: aggReq?.job_description_keys?.mandatory_companies || [],
                industries: aggReq?.job_description_keys?.industries || [],
                mandatory_industries: aggReq?.job_description_keys?.mandatory_industries || []
              }
              payload.jobtitles = _.uniq(aggReq?.jobtitles.concat(aggReq?.pastjobtitles)) || [];
              payload.skills = _.uniq(aggReq?.preferredskills?.concat(aggReq?.mandatoryskills)) || [];
            }

                this.titlesTabFunctionsPayload = payload

    this.isFunctionSalaryPending = true;

    if (jobtitles?.length > 0 && skills?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
              this.isFunctionSalaryPending = false;

      this.functionsortdata = this.functionsortdata.map(title => {
        title.median_salary = "N/A";
        title.confidence_score = "N/A";
        title.job_doc_count = 0;
        return title;
      })
      } else if(!this.isComingFromJD && !this.isComingFromNLSearch && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')){
   this.hasJobDemand = false;
            this.isFunctionSalaryPending = false;
        this.functionsAggregates = [];
        this.setFunctionJobsAggregates();
      }



      else {
    this.talentInsightsService.getJobsAggregates(payload).subscribe((response: any) => {
      const tempData = response?.data?.aggregations['function-median_salary'];
      this.functionsAggregates = tempData;
      this.isFunctionSalaryPending = false;
      this.setFunctionJobsAggregates();
    })
      }

    } else {
            this.isFunctionSalaryPending = false;

            this.functionsortdata = this.functionsortdata.map(title => {
        title.median_salary = "N/A";
        title.confidence_score = "N/A";
        title.job_doc_count = 0;
        return title;
      })
    }
  }

  /**
  * Function set the start and end of aggreggate data according to page number in title container
  * @param index page number in pagination
  */
  setPageFunction(index: number) {
    this.startFunction = (index - 1) * this.pageSizeFunction;
    this.endFunction = this.startFunction + this.pageSizeFunction;
    this.currentFunctionPage = index;
    this.manualfunctionsort();

  }

  /**
   * Get percentage of function count from total function count
   * @param value
   * @returns
   */
  getFunctionPercentage(value) {
    return ((value / this.totalResultCountFunction) * 100).toFixed(2);
  }

  manualSortSeniority() {
    this.reSortSeniority(this.senioritySort)
  }


  reSortSeniority(sort) {
    const tempData = this.senioritySortData;

    if (!sort || !sort.active || sort.direction === '') {
      this.currentsenioritydata = tempData;
      this.currentseniority = new MatTableDataSource(this.currentsenioritydata);
      this.currentseniority.sort = this.senioritySort;
      return;
    }

    this.senioritySortData = tempData.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'doc_count': return this.compare(a.doc_count, b.doc_count, isAsc);
        case 'job_doc_count': return this.compare(a.job_doc_count, b.job_doc_count, isAsc);
        default: return 0;
      }
    });

    this.currentsenioritydata = this.senioritySortData.slice(this.start, this.end);
    this.currentseniority = new MatTableDataSource(this.currentsenioritydata);
    this.currentseniority.sort = this.senioritySort;
  }

  getCurrency() {
    this.hasJobDemand = true;
    this.hasMedianSalary = true;
    this.titlesSortData = this.titlesSortData.map(title => {
      title.median_salary = "";
      title.confidence_score = "";
      title.job_doc_count = "";
      return title;
    })
    this.senioritySortData = this.senioritySortData.map(title => {
      title.median_salary = "";
      title.confidence_score = "";
      title.job_doc_count = "";
      return title;
    })

        this.functionsortdata = this.functionsortdata.map(title => {
      title.median_salary = "";
      title.confidence_score = "";
      title.job_doc_count = "";
      return title;
    })
    this.talentInsightsService.getCountryCurrency().subscribe((response: any) => {
      this.currencyData = response?.data;
      this.filteredCurrencies = this.currencyData.slice(0, 5);
      const currency = this.localstorageservice.getItem('jobCurrency');

      if (currency) {
        const selectedCurrency = this.currencyData.find((x: any) => x.target_currency === currency);
        if (selectedCurrency) {
          this.selectedCurrency = selectedCurrency;
          this.target_currency_rate = selectedCurrency.rate;
          this.currency = selectedCurrency.target_currency;
          this.target_fav_icon = selectedCurrency.target_currency_fav_icon;
          this.seniorityCurrency = selectedCurrency.target_currency;
          this.target_currency_rate_seniority = selectedCurrency.rate;
          this.target_fav_icon_seniority = selectedCurrency.target_currency_fav_icon;
          this.currency_symbol = selectedCurrency.target_currency_symbol;
                this.functionCurrencyData.currency =  selectedCurrency.target_currency;
      this.functionCurrencyData.target_currency_rate = selectedCurrency.rate;
      this.functionCurrencyData.target_fav_icon =  selectedCurrency.target_currency_fav_icon;

        }
      }
      this.getJobsAggregates();
      this.getSeniorityAggregates();
      this.getFunctionAggregate();
    })
  }

  onTypeAheadSearch(event: any) {
    const input = event.target.value.toLowerCase();
    this.filteredCurrencies = this.currencyData.filter(x => x.target_currency.toLowerCase().includes(input));
    this.filteredCurrencies = this.filteredCurrencies.slice(0, 5);
  }

  selectedItem(currencyItem: any, type: string) {
  //  if (type === 'seniority') {
      this.seniorityCurrency = currencyItem.target_currency;
      this.target_currency_rate_seniority = currencyItem.rate;
      this.target_fav_icon_seniority = currencyItem.target_currency_fav_icon;
      this.localstorageservice.setItem('jobCurrency', this.currency);

      this.senioritySortData = this.senioritySortData.map(seniority => {
        if (this.target_fav_icon_seniority == 'fa-money-bill') {
          seniority.median_salary = seniority.median_salary_min ? `${this.seniorityCurrency} ${this.formatNumber((seniority.median_salary_min) * this.target_currency_rate_seniority)} - ${this.seniorityCurrency} ${this.formatNumber(seniority.median_salary_max * this.target_currency_rate_seniority)}` : "N/A";
        } else {
          seniority.median_salary = seniority.median_salary_min ? `<i class="fa-solid ${this.target_fav_icon_seniority}"></i>${this.formatNumber((seniority.median_salary_min) * this.target_currency_rate_seniority)} - <i class="fa-solid ${this.target_fav_icon_seniority}"></i>${this.formatNumber(seniority.median_salary_max * this.target_currency_rate_seniority)}` : "N/A";
        }
        return seniority;
      });
      this.getindustriesdataai(this.senioritySortData);
 //   } else if (type === 'function') {
      this.functionCurrencyData.currency = currencyItem.target_currency;
      this.functionCurrencyData.target_currency_rate = currencyItem.rate;
      this.functionCurrencyData.target_fav_icon = currencyItem.target_currency_fav_icon;
      this.localstorageservice.setItem('jobCurrency', this.currency);
        this.functionsortdata = this.functionsortdata.map(fun => {
        if (this.target_fav_icon == 'fa-money-bill') {
          fun.median_salary = fun.median_salary_min ? `${this.functionCurrencyData.currency} ${this.formatNumber((fun.median_salary_min) * this.functionCurrencyData.target_currency_rate)} - ${this.functionCurrencyData.currency} ${this.formatNumber(fun.median_salary_max * this.functionCurrencyData.target_currency_rate)}` : "N/A";
        } else {
          fun.median_salary = fun.median_salary_min ? `<i class="fa-solid ${this.functionCurrencyData.target_fav_icon}"></i>${this.formatNumber((fun.median_salary_min) * this.functionCurrencyData.target_currency_rate)} - <i class="fa-solid ${this.functionCurrencyData.target_fav_icon}"></i>${this.formatNumber(fun.median_salary_max * this.functionCurrencyData.target_currency_rate)}` : "N/A";
        }
        return fun;
      });
      this.getindustriesdataai(this.titlesSortData, 'functions');
   // }
  //  else {
      this.currency = currencyItem.target_currency;
      this.selectedCurrency = currencyItem;
      this.target_currency_rate = currencyItem.rate;
      this.target_fav_icon = currencyItem.target_currency_fav_icon;
      this.localstorageservice.setItem('jobCurrency', this.currency);
      this.titlesSortData = this.titlesSortData.map(title => {
        if (this.target_fav_icon == 'fa-money-bill') {
          title.median_salary = title.median_salary_min ? `${this.currency} ${this.formatNumber((title.median_salary_min) * this.target_currency_rate)} - ${this.currency} ${this.formatNumber(title.median_salary_max * this.target_currency_rate)}` : "N/A";
        } else {
          title.median_salary = title.median_salary_min ? `<i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber((title.median_salary_min) * this.target_currency_rate)} - <i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber(title.median_salary_max * this.target_currency_rate)}` : "N/A";
        }
        return title;
      });
      this.getindustriesdataai(this.titlesSortData);
  //  }
    // this.getCurrency();
  }

  clearCurrencyInput(type: string) {
    if (type === 'seniority') {
      this.seniorityCurrency = '';
    } else if(type === 'function') {
      this.functionCurrencyData.currency = '';
    } else {
      this.currency = '';
    }
    this.filteredCurrencies = this.currencyData.slice(0, 5);
  }

  getCurrencyData(source?: string) {
    const filterData = this.filterDataHandlerService.fetchFilterData;
    const aggReq = this.aggService.getRequestWithFilters();
    if (filterData && filterData.locationSelectedList.length > 0) {
      if (source === 'filterChange') {
        const locations = filterData.locationSelectedList.map(loc => loc.key.replace('.searchastext', ''));
        const location = locations.join(',');
        const payload = { locations: locations }
        this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
          if (res.status === 'success' && res.data) {
            this.localstorageservice.setItem('jobCurrency', res.data.base_currency);
            this.localstorageservice.setItem('currencyCountry', res.data.country_name);
            this.setUpdatedData();
          }
        })

      } else {
        this.currency = this.localstorageservice.getItem('jobCurrency') || 'USD';
        this.setUpdatedData();
      }
    } else if (this.jdService.isComingFromJobDescription) {
      if (source === 'jdUpdate') {
        if (aggReq && aggReq?.job_description_keys && aggReq?.job_description_keys?.locations?.length > 0) {
          const locations = aggReq.job_description_keys?.locations;
          const payload = { locations: locations }
          this.talentInsightsService.getLocationCurrency(payload).subscribe((res: any) => {
            if (res.status === 'success' && res.data) {
              this.localstorageservice.setItem('jobCurrency', res.data.base_currency);
              this.localstorageservice.setItem('currencyCountry', res.data.country_name);
              this.setUpdatedData();
            }
          })
        }
      } else {
        this.currency = this.localstorageservice.getItem('jobCurrency') || 'USD';
        this.setUpdatedData();
      }


    } else {
      this.currency = this.localstorageservice.getItem('jobCurrency') || 'USD';
      this.setUpdatedData();
    }

  }
  /**
   * Retrun true if data is still pending
   */
  getDataPendingStatus(){
    return this.hasMedianSalary || this.hasJobDemand || this.hasMedianSalarySeniority || this.isSeniorityApiCalled || this.isFunctionPending || this.isFunctionSalaryPending;
  }

  setTitlesJobAggregates() {
    const aggReq = this.aggService.getRequestWithFilters();
    this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions');
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    if (skills?.length > 0 && jobtitles?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
        this.titlesSortData = this.titlesSortData.map(title => {
          title.median_salary = "N/A";
          title.confidence_score = "N/A";
          title.job_doc_count = 0;
          return title;
        });
        this.getindustriesdataai(this.titlesSortData);
      } else {
        this.titlesSortData.map(title => {
          const medianSalaryData = this.titlesJobAggregates.find(item => item.key.toLowerCase().trim() === title.key.toLowerCase().trim());
          if (medianSalaryData) {
            if (this.target_fav_icon == 'fa-money-bill') {
              title.median_salary = medianSalaryData.median_salary_min.value ? `${this.currency} ${this.formatNumber((medianSalaryData.median_salary_min.value) * this.target_currency_rate)} - ${this.currency} ${this.formatNumber(medianSalaryData.median_salary_max.value * this.target_currency_rate)}` : "N/A";

            } else {
              title.median_salary = medianSalaryData.median_salary_min.value ? `<i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber((medianSalaryData.median_salary_min.value) * this.target_currency_rate)} - <i class="fa-solid ${this.target_fav_icon}"></i>${this.formatNumber(medianSalaryData.median_salary_max.value * this.target_currency_rate)}` : "N/A";
            }
            title.median_salary_min = medianSalaryData.median_salary_min.value;
            title.median_salary_max = medianSalaryData.median_salary_max.value;
            title.confidence_score = medianSalaryData.confidence_score;
            title.job_doc_count = medianSalaryData?.job_demand?.doc_count || 0;
          } else {
            title.median_salary = "N/A";
            title.confidence_score = "N/A";
            title.job_doc_count = 0;
          }
          return title;
        });
        this.getindustriesdataai(this.titlesSortData);

      }


    } else {
      this.titlesSortData = this.titlesSortData.map(title => {
        title.median_salary = "N/A";
        title.confidence_score = "N/A";
        title.job_doc_count = 0;
        return title;
      })
      this.getindustriesdataai(this.titlesSortData);

    }
  }

  setSeniorityJobsAggregates() {
    const aggReq = this.aggService.getRequestWithFilters();
    this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions');
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    if (skills?.length > 0 && jobtitles?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
        if(this.senioritySortData?.length) {
        this.senioritySortData = this.senioritySortData.map(title => {
          title.median_salary = "N/A";
          title.confidence_score = "N/A";
          title.job_doc_count = 0;
          return title;
        });
        }

        this.getindustriesdataai(this.senioritySortData, 'seniority');
      } else {
        this.senioritySortData.map(title => {
          const medianSalaryData = this.seniorityJobsAggregates.find(item => item.key.toLowerCase().trim() === title.key.toLowerCase().trim());
          if (medianSalaryData) {
            if (this.target_fav_icon_seniority == 'fa-money-bill') {
              title.median_salary = medianSalaryData.median_salary_min.value ? `${this.seniorityCurrency} ${this.formatNumber((medianSalaryData.median_salary_min.value) * this.target_currency_rate_seniority)} - ${this.seniorityCurrency} ${this.formatNumber(medianSalaryData.median_salary_max.value * this.target_currency_rate_seniority)}` : "N/A";
            } else {
              title.median_salary = medianSalaryData.median_salary_min.value ? `<i class="fa-solid ${this.target_fav_icon_seniority}"></i>${this.formatNumber((medianSalaryData.median_salary_min.value) * this.target_currency_rate_seniority)} - <i class="fa-solid ${this.target_fav_icon_seniority}"></i>${this.formatNumber(medianSalaryData.median_salary_max.value * this.target_currency_rate_seniority)}` : "N/A";
            }
            title.median_salary_min = medianSalaryData.median_salary_min.value;
            title.median_salary_max = medianSalaryData.median_salary_max.value;
            title.confidence_score = medianSalaryData.confidence_score;
            title.job_doc_count = medianSalaryData?.job_demand?.doc_count || 0;
          } else {
            title.median_salary = "N/A";
            title.confidence_score = "N/A";
            title.job_doc_count = 0;
          }
          return title;
        });
        this.getindustriesdataai(this.senioritySortData, 'seniority');
      }
    } else {
      this.senioritySortData = this.senioritySortData.map(title => {
        title.median_salary = "N/A";
        title.confidence_score = "N/A";
        title.job_doc_count = 0;
        return title;
      });
      this.getindustriesdataai(this.senioritySortData, 'seniority');
    }
  }

  setFunctionJobsAggregates() {
    const aggReq = this.aggService.getRequestWithFilters();
    this.aiSuggestions = this.localstorageservice.getItem('aiSuggestions');
    const skills = _.uniq(this.aiSuggestions?.skills?.concat(aggReq?.preferredskills || []).concat(aggReq?.mandatoryskills).concat(aggReq?.job_description_keys?.skills || []));
    const jobtitles = _.uniq(this.aiSuggestions?.jobtitles?.concat(aggReq?.jobtitles || []).concat(aggReq?.job_description_keys?.job_titles || []).concat(aggReq?.pastjobtitles?.length ? aggReq.pastjobtitles : []));
    if (skills?.length > 0 && jobtitles?.length > 0) {
      const jdSkills = aggReq?.job_description_keys?.skills || [];
      const jdJobtitles = aggReq?.job_description_keys?.job_titles || [];
      if ((aggReq?.exclude_jobtitles?.length > 0 && (aggReq?.jobtitles?.length == 0 && aggReq?.preferredskills?.length == 0 && aggReq?.mandatoryskills?.length == 0
        && (jdSkills?.length == 0 && jdJobtitles?.length == 0 && aggReq?.pastjobtitles?.length == 0 && aggReq?.booleanquery == '*')
      ))) {
        this.functionsortdata = this.functionsortdata.map(title => {
          title.median_salary = "N/A";
          title.confidence_score = "N/A";
          title.job_doc_count = 0;
          return title;
        });
        this.getindustriesdataai(this.functionsortdata);
      } else {
      this.functionsortdata.map(title => {
        const medianSalaryData = this.functionsAggregates.find(item => item.key.toLowerCase().trim() === title.key.toLowerCase().trim());
        if (medianSalaryData) {
          if (this.functionCurrencyData.target_fav_icon == 'fa-money-bill') {
            title.median_salary = medianSalaryData.median_salary_min.value ? `${this.functionCurrencyData.currency} ${this.formatNumber((medianSalaryData.median_salary_min.value) * this.target_currency_rate_seniority)} - ${this.functionCurrencyData.currency} ${this.formatNumber(medianSalaryData.median_salary_max.value * this.target_currency_rate_seniority)}` : "N/A";
          } else {
            title.median_salary = medianSalaryData.median_salary_min.value ? `<i class="fa-solid ${this.functionCurrencyData.target_fav_icon}"></i>${this.formatNumber((medianSalaryData.median_salary_min.value) * this.target_currency_rate_seniority)} - <i class="fa-solid ${this.functionCurrencyData.target_fav_icon}"></i>${this.formatNumber(medianSalaryData.median_salary_max.value * this.target_currency_rate_seniority)}` : "N/A";
          }
          title.median_salary_min = medianSalaryData.median_salary_min.value;
          title.median_salary_max = medianSalaryData.median_salary_max.value;
          title.confidence_score = medianSalaryData.confidence_score;
          title.job_doc_count = medianSalaryData?.job_demand?.doc_count || 0;
        } else {
          title.median_salary = "N/A";
          title.confidence_score = "N/A";
          title.job_doc_count = 0;
        }
        return title;
      });
        this.getindustriesdataai(this.functionsortdata);

      }


    } else {
      this.functionsortdata = this.functionsortdata.map(title => {
        title.median_salary = "N/A";
        title.confidence_score = "N/A";
        title.job_doc_count = 0;
        return title;
      })
      this.getindustriesdataai(this.functionsortdata);

    }
  }


openJoblistSlider(type:any, value:any){
    if(type == 'jobtitles'){
      Object.assign(this.titlesTabPayload, {mandatory_jobtitles:[value]})
      this.sendDataToSliderSubject.next(this.titlesTabPayload);

    }else if(type == 'functions'){
      Object.assign(this.titlesTabFunctionsPayload, {mandatory_functions:[value]})
      this.sendDataToSliderSubject.next(this.titlesTabFunctionsPayload);

    } else if(type == 'seniority'){
      Object.assign(this.titlesTabSeniorityPayload, {mandatory_seniority:[value]})
      this.sendDataToSliderSubject.next(this.titlesTabSeniorityPayload);

    }
      // this.sendDataToSliderSubject.next(this.titlesTabPayload);

      this.toOpenSliderFromTabSubject.next({isOpen:true})
  }
}
